import React from "react";
import {
  RotateCcw,
  Download,
} from "lucide-react";

const EmploymentToolbar = ({
  onReset,
  onExport,
  loading = false,
}) => {
  return (
    <div className="flex items-center justify-between">
      {/* LEFT SIDE */}

      <div>
        <p className="text-sm text-slate-500">
          Manage and review employee employment records.
        </p>
      </div>

      {/* ACTIONS */}

      <div className="flex items-center gap-2">
        {/* Reset Filters */}

        <button
          type="button"
          onClick={onReset}
          disabled={loading}
          className="
            flex
            h-9
            items-center
            gap-2
            rounded-lg
            border
            border-slate-200
            bg-white
            px-3
            text-sm
            font-medium
            text-slate-600
            transition
            hover:bg-slate-50
            hover:text-slate-900
            disabled:cursor-not-allowed
            disabled:opacity-50
          "
        >
          <RotateCcw
            size={15}
            strokeWidth={1.8}
          />

          <span>Reset Filters</span>
        </button>

        {/* Export */}

        <button
          type="button"
          onClick={onExport}
          disabled={loading}
          className="
            flex
            h-9
            items-center
            gap-2
            rounded-lg
            border
            border-slate-200
            bg-white
            px-3
            text-sm
            font-medium
            text-slate-600
            transition
            hover:bg-slate-50
            hover:text-slate-900
            disabled:cursor-not-allowed
            disabled:opacity-50
          "
        >
          <Download
            size={15}
            strokeWidth={1.8}
          />

          <span>Export</span>
        </button>
      </div>
    </div>
  );
};

export default EmploymentToolbar;